import GET_ALL_SELECTED_CRITERIA from '../store/actions';
import useFilteringFacetsStore from '../store/filteringFacetsStore';
import { CLEAR_ALL_SELECTED_VALUES, REPLACE_SELECTED_VALUES, SET_ROUTE_QUERY } from '../store/mutations';

export const useStoreUtils = () => {
  const store = useFilteringFacetsStore();

  const triggerSelectedFacetsUpdate = () => store[GET_ALL_SELECTED_CRITERIA]();

  const replaceSelectedValues = (facet) => {
    store[REPLACE_SELECTED_VALUES]({ ...facet });
  };

  const clearAllSelectedValues = () => {
    store[CLEAR_ALL_SELECTED_VALUES]();
  };

  const setRouteQuery = (query = {}) => {
    store[SET_ROUTE_QUERY](query);
  };

  return {
    triggerSelectedFacetsUpdate,
    replaceSelectedValues,
    clearAllSelectedValues,
    setRouteQuery,
  };
};
